import React from "react";
import styled from "styled-components";
import { rem } from "polished";

import CloseButton from "./CloseButton";

import mq from "../../helpers/media-queries";

const Container = styled.div`
	height: 100%;
	// padding: ${rem(55)};
	// padding-top: ${rem(120)};
	background: #fff;
	border-radius: 20px;
	overflow: hidden;
	position: relative;

	&::before {
		content: "";
		display: block;
		position: absolute;
		bottom: 0;
		right: 0;
		height: ${rem(60)};
		background: linear-gradient(transparent, white 90%);
		z-index: 1;
		bottom: 0;
		width: 100%;
	}
`;

const InnerTextContainer = styled.div`
	overflow: scroll;
	height: 100%;

	${mq("sm", "max")} {
		padding: ${rem(27.5)};
		padding-top: ${rem(60)};
	}

	${mq("sm", "min")} {
		padding: ${rem(55)};
		padding-top: ${rem(120)};
		display: flex;
		justify-content: space-between;
	}
`;

const Column = styled.div`
	${mq("sm", "min")} {
		padding-right: ${rem(25)};
		width: ${rem(150)};
	}

	&:last-of-type {
		// margin-right: ${rem(-25)};
	}
`;

const Image = styled.div`
	width: ${rem(108)};
	max-width: 90%;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	border-radius: 999em;
	margin-bottom: ${rem(22)};

	&::after {
		content: "";
		display: block;
		padding-top: 100%;
	}
`;

const Title = styled.h4`
	font-weight: bold;
	font-size: ${rem(24)};
	line-height: 1.3;
	margin-bottom: ${rem(8)};
	font-family: sans-serif;
`;

const Text = styled.div`
	font-size: ${rem(13)};
	line-height: 1.5;
	color: #282a2c;
	font-family: sans-serif;
	padding-bottom: ${rem(55)};
`;

const Variations = ({ closeModal, items }) => (
	<Container>
		<CloseButton closeModal={closeModal} />

		<InnerTextContainer>
			{items.map((item, index) => (
				<Column key={index}>
					<Image style={{ backgroundImage: `url(${item.image})` }} />
					<Title>{item.title}</Title>
					<Text>{item.text}</Text>
				</Column>
			))}
		</InnerTextContainer>
	</Container>
);

export default Variations;
